import { Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type ActivityDetailsQuestionsProps = {
  questions?: string[];
  showCard?: boolean;
};

export const ActivityDetailsQuestions = ({ questions, showCard = true }: ActivityDetailsQuestionsProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details" });

  if (!questions || questions.length === 0) {
    return null;
  }

  const content = (
    <Stack gap="spacingLg">
      <Typography variant="h5">{t("showInterestQuestions")}</Typography>
      {questions.map((question, index) => (
        <Stack key={index} gap="spacingSm">
          <Typography variant="bodyBold">{t("question", { id: index + 1 })}</Typography>
          <Typography variant="bodyRegular">{question}</Typography>
        </Stack>
      ))}
    </Stack>
  );

  if (!showCard) {
    return content;
  }

  return (
    <Tile variant="light" paddingVariant="lg" qaId="ActivityDetailsQuestions">
      {content}
    </Tile>
  );
};
